import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { Btn } from "../../../AbstractElements";
import { useUpdateSTP } from "../hooks/useSTP";
import { showToast } from "../../../utils/toastUtils";

type ProductCardProps = {
  setIsModalOpen?: any;
  isModalOpen?: any;
  toggleModal?: any;
  title?: any;
  rowData?: any;
  StpStatusData?: any;
};

const STPEditModal: React.FC<ProductCardProps> = ({
  StpStatusData,
  rowData,
  setIsModalOpen,
  isModalOpen,
  title,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [modalValues, setModalValues] = useState<any>({
    PositionId: "",
    StpStatus: "",
    StpApprovedBy: "",
    ApprovedDate: "",
    RejectedReason: "",
    AppliedFromDate: "",
    AppliedToDate: "",
  });
  const [stpStatus, setStpStatus] = useState<any>([]);
  console.log("rowData", rowData);
  const { mutate: updateMutate, isPending: isPending } = useUpdateSTP();

  const fetchStpStatus = (data: any) => {
    let formattedData = Object.keys(data)?.reduce((arr: any, item: any) => {
      arr.push({ id: item, label: data[item] });
      // arr.push({ id: item, label: item });
      return arr;
    }, []);
    setStpStatus(formattedData);
  };
  useEffect(() => {
    if (StpStatusData && Object.keys(StpStatusData || {})?.length) {
      fetchStpStatus(StpStatusData || {});
    }
  }, [StpStatusData]);

  const handleClose = () => {
    setIsModalOpen(false);
    setModalValues((prevState: any) => ({
      ...prevState,
      PositionId: "",
      StpStatus: "",
      StpApprovedBy: "",
      ApprovedDate: "",
      RejectedReason: "",
      AppliedFromDate: "",
      AppliedToDate: "",
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (submitting) return; // block multiple submissions
    setSubmitting(true);

    if (!modalValues?.StpStatus) {
      showToast.warning("Please select status.");
      setSubmitting(false);
      return;
    }
    if (modalValues?.StpStatus === "rejected" && !modalValues?.RejectedReason) {
      showToast.warning("Please enter the rejection reason.");
      setSubmitting(false);
      return;
    }

    const body = {
      PositionId: Number(modalValues?.PositionId.id) || "",
      StpStatus: modalValues?.StpStatus || "",
      StpApprovedBy: Number(modalValues?.StpApprovedBy?.id) || "",
      ApprovedDate: modalValues?.ApprovedDate || "",
      RejectedReason: modalValues?.RejectedReason || "",
      AppliedFromDate: modalValues?.AppliedFromDate || "",
      AppliedToDate: modalValues?.AppliedToDate || "",
    };

    console.log("body", body);

    updateMutate(
      { id: Number(rowData?.StpId), body },
      {
        onSuccess: () => {
          handleClose();
          setSubmitting(false);
        },
        onError: () => {
          toast.error("Failed to update STP.");
          setSubmitting(false);
        },
      }
    );
  };

  // alert(modalValues?.StpStatus)
  useEffect(() => {
    if (isModalOpen && rowData) {
      setModalValues({
        PositionId: { id: rowData?.PositionId, label: rowData?.PositionName },
        StpStatus: rowData?.StpStatus,
        StpApprovedBy: {
          id: rowData?.StpApprovedBy,
          label: rowData?.StpApprovedByName || "",
        },
        ApprovedDate: rowData?.ApprovedDate,
        RejectedReason: rowData?.rejected_reason || "",
        AppliedFromDate: rowData?.AppliedFromDate,
        AppliedToDate: rowData?.AppliedToDate,
      });
    }
  }, [rowData, isModalOpen]);

  return (
    <>
      {modalValues && Object.values(modalValues || {})?.length > 0 && (
        <RouteModal
          isOpen={isModalOpen}
          toggle={() => {
            setIsModalOpen(!isModalOpen);
            setModalValues((prevState: any) => ({
              ...prevState,
              PositionId: "",
              StpStatus: "",
              StpApprovedBy: "",
              ApprovedDate: "",
              RejectedReason: "",
              AppliedFromDate: "",
              AppliedToDate: "",
            }));
          }}
          title={title}
          // title="Add MTP"
          size="md"
          content={
            <form onSubmit={handleSubmit}>
              <div className="row mb-0">
                <RouteDropdown
                  options={stpStatus || []}
                  value={modalValues?.StpStatus}
                  // onInputChange={(val:any)=>{console.log('inputChange',val)}}
                  onChange={(value: any) => {
                    setModalValues((prevState: any) => ({
                      ...prevState,
                      StpStatus: value,
                    }));
                  }}
                  DropdownHeading="Status*"
                />
                {modalValues?.StpStatus === "rejected" && (
                  <CustomInput
                    placeholder="Type..."
                    // disabled={true}
                    onChange={(e: any) => {
                      setModalValues((prevState: any) => ({
                        ...prevState,
                        RejectedReason: e.target.value,
                      }));
                    }}
                    value={modalValues?.RejectedReason}
                    required={true}
                    label="Rejected Reason"
                    style={{
                      border: "1px solid #EDEDED",
                      borderRadius: "4px",
                      padding: "10px",
                      fontSize: "14px",
                      backgroundColor: "#fff",
                    }}
                  />
                )}

                <div style={{ height: 20 }} />
                <div className="d-flex justify-content-start gap-2">
                  <Btn
                    style={{ backgroundColor: "#43B9B2", color: "white" }}
                    type="submit"
                    disabled={isPending || submitting}
                  >
                    {submitting ? "Updating..." : "Update"}
                  </Btn>

                  <Btn
                    style={{
                      backgroundColor: "#F9FAFC",
                      color: "#000",
                      border: "1px solid #E0E0E0",
                    }}
                    type="button"
                    onClick={() => {
                      setIsModalOpen(false);
                      setModalValues((prevState: any) => ({
                        ...prevState,
                        PositionId: "",
                        StpStatus: "",
                        StpApprovedBy: "",
                        ApprovedDate: "",
                        RejectedReason: "",
                        AppliedFromDate: "",
                        AppliedToDate: "",
                      }));
                    }}
                  >
                    Cancel
                  </Btn>
                </div>
              </div>
            </form>
          }
        />
      )}
    </>
  );
};

export default STPEditModal;
